import { View, ViewProps } from 'react-native';

export function RowStack(props: ViewProps) {
  return (
    <View
      {...props}
      style={[{ flexDirection: 'row', alignItems: 'center' }, props.style]}
    />
  );
}

export function ColStack(props: ViewProps) {
  return (
    <View
      {...props}
      style={[
        { flexDirection: 'column', alignItems: 'flex-start' },
        props.style,
      ]}
    />
  );
}

export function Spacer({
  size,
  direction,
}: {
  size: number | 'stretch';
  direction?: 'horizontal' | 'vertical';
}) {
  const width = direction === 'vertical' ? 1 : size;
  const height = direction === 'horizontal' ? 1 : size;
  return <View style={size === 'stretch' ? { flex: 1 } : { width, height }} />;
}

export { default as alert } from './alert';
export { default as KeyboardAvoidingView } from './KeyboardAvoidingView';
export * from './Pressable';
